export default {
  label: 'Verzenden naar',
  counter: '{{current}} van {{max}}',
  default_badge: 'Standaard',
  remove: '{{email}} verwijderen',
  add_back: 'Weer toevoegen',
  empty: 'Voeg minstens één e-mailadres toe.',
  add_label: 'E-mailadres toevoegen',
  placeholder: 'naam@voorbeeld.nl',
  add: 'Toevoegen',
  hint: 'Maximaal {{max}} e-mailadressen. Elk adres krijgt een eigen e-mail.',
  hint_full: 'Dit is het maximum voor deze lijst. Verwijder een e-mailadres om een ander toe te voegen.',
  errors: {
    full: 'U kunt maximaal {{max}} e-mailadressen toevoegen.',
    invalid: 'Voer een e-mailadres in zoals naam@voorbeeld.nl.',
    duplicate: '{{email}} staat al in de lijst.',
  },
};
